import Vue from 'vue';
import App from './App.vue';
import router from './router';
import vuetify from './plugins/vuetify';
import DatePicker from 'vuejs-datepicker';
import Dialog from '@/components/Dialog.vue';
import OverLay from '@/components/OverLay.vue';
Vue.component('datepicker', DatePicker);
Vue.component('dialog-confirm', Dialog);
Vue.component('OverLay', OverLay);

const store = require('./store');

// �J���p
Vue.config.devtools = true;

Vue.config.productionTip = false;

//API URL BASE
Vue.prototype.$API_URL = process.env.VUE_APP_API_BASE_URL;

//API Request Header
Vue.prototype.$AXIOS_REQ_HEADER = {
  headers: {
    'Content-Type': 'application/json',
    'access-control-allow-origin': '*',
    'access-control-allow-methods': '*',
    'access-control-allow-headers': '*'
  },
  withCredentials: true
};

new Vue({
  store,
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app');
